const school = [
    {
        "name": "Western Governors University",
        "subject": "Master of Science in Cybersecurity and Information Assurance",
        "time": "Feb 2026",
        "description": "· Graduate program aligned with the NICE Framework, NSA Center of Academic Excellence guidelines, and the CISSP Common Body of Knowledge (CBK).\n\n· Focused on advanced cybersecurity domains including Cloud Security, Governance, Risk, and Compliance (GRC), Penetration Testing, and Enterprise Architecture Design.\n\n· Curriculum emphasizes real-world, hands-on security practices and preparation for industry-recognized certifications.",
        "skills": ""
    },
    {
        "name": "Western Governors University",
        "subject": "Bachelor of Science in Cybersecurity and Information Assurance",
        "time": "",
        "description": "· Balancing academic coursework with management experience\n\n· Recipient of two Excellence Awards for research and operational efficiency proposals",
        "skills": ""
    },
    {
        "name": "UC Davis",
        "subject": "Coding Bootcamp Certificate",
        "time": "",
        "description": "· Completed a 24-week intensive program focused on full-stack web development",
        "skills": "HTML5 · CSS3 · JavaScript · jQuery · Bootstrap · Firebase · Node.js · MySQL · MongoDB · Express · React"
    },
    {
        "name": "De Anza College",
        "subject": "Computer Science",
        "time": "",
        "description": "",
        "skills": "C++, Java, Linux"
    },
    {
        "name": "Silicon Valley Career Technical Education",
        "subject": "Mobile App Design & Computer Coding",
        "time": "",
        "description": "",
        "skills": "HTML, CSS, JavaScript, Swift"
    }
]
export default school;